/* July 4th: auto-add 2 free Pebble Elevate pillows when any mattress is in the cart.
   Native BXGY discount zeroes them; this only ensures they're present. Dawn pub/sub. */
(function () {
  const MATTRESS_IDS = [9047186636955, 8716405309595, 8716398755995, 8716396495003];
  const GIFT_VARIANT = 47350172123291; // Elevate Standard
  const GIFT_QTY = 2;
  const DECLINED = 'jul4_gift_declined';
  let busy = false;
  let lastGiftQty = null;

  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const hasMattress = (cart) => cart.items.some((i) => MATTRESS_IDS.includes(i.product_id));
  const giftQty = (cart) =>
    cart.items.filter((i) => i.variant_id === GIFT_VARIANT).reduce((n, i) => n + i.quantity, 0);

  function sectionsForDrawer() {
    const el = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    try {
      return el && el.getSectionsToRender ? el.getSectionsToRender().map((s) => s.id) : [];
    } catch (e) {
      return [];
    }
  }

  function rerender(state) {
    const el = document.querySelector('cart-drawer');
    if (el && el.renderContents && state && state.sections) el.renderContents(state);
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && state && state.sections && state.sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
      const inner = doc.querySelector('.shopify-section') || doc.body;
      if (inner) bubble.innerHTML = inner.innerHTML;
    }
  }

  async function reconcile(trigger) {
    if (busy) return;
    busy = true;
    try {
      const cart = await getCart();
      const mattress = hasMattress(cart);
      const have = giftQty(cart);
      const declined = sessionStorage.getItem(DECLINED) === '1';

      // Shopper manually removed/reduced the gift while a mattress is still present -> respect it.
      if (lastGiftQty !== null && have < lastGiftQty && have < GIFT_QTY && mattress && trigger === 'cart-update') {
        sessionStorage.setItem(DECLINED, '1');
        lastGiftQty = have;
        return;
      }
      // No mattress -> remove any gift pillows WE auto-added (they are only free WITH a
      // mattress; leaving them would silently charge the shopper). Re-arm for next time.
      if (!mattress) {
        sessionStorage.removeItem(DECLINED);
        const ours = cart.items.filter((i) => i.properties && i.properties._jul4_gift === 'true');
        if (ours.length) {
          const updates = {};
          ours.forEach((i) => {
            updates[i.key] = 0;
          });
          const state = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates, sections: sectionsForDrawer(), sections_url: window.location.pathname }),
          }).then((r) => r.json());
          rerender(state);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jul4-gift' });
          }
        }
        lastGiftQty = 0;
        return;
      }

      if (mattress && !declined && have < GIFT_QTY) {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: GIFT_VARIANT, quantity: GIFT_QTY - have, properties: { _jul4_gift: 'true' } }],
            sections: sectionsForDrawer(),
            sections_url: window.location.pathname,
          }),
        });
        const state = await res.json().catch(() => null);
        const added = res.ok && state && !state.status; // Shopify sets `status` (e.g. 422) on error

        // Authoritative re-read — never assume the resulting quantity (a failed add must NOT
        // look like a present gift, or the next cart-update would falsely mark it declined).
        const after = await getCart();
        let giftNow = giftQty(after);

        // Belt-and-suspenders: if a tab/refresh race added more than GIFT_QTY, trim our excess.
        if (giftNow > GIFT_QTY) {
          const ours = after.items.filter((i) => i.properties && i.properties._jul4_gift === 'true');
          const updates = {};
          let excess = giftNow - GIFT_QTY;
          for (const i of ours) {
            if (excess <= 0) break;
            const cut = Math.min(i.quantity, excess);
            updates[i.key] = i.quantity - cut;
            excess -= cut;
          }
          const trimmed = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates, sections: sectionsForDrawer(), sections_url: window.location.pathname }),
          }).then((r) => r.json()).catch(() => null);
          if (trimmed) {
            rerender(trimmed);
            giftNow = giftQty(trimmed);
          }
        } else if (added) {
          rerender(state);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jul4-gift' });
        }
        lastGiftQty = giftNow;
      } else {
        lastGiftQty = have;
      }
    } catch (e) {
      /* non-fatal: the native discount still applies once the shopper adds pillows */
    } finally {
      busy = false;
    }
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
        if (data && data.source === 'jul4-gift') return; // ignore our own publish -> no loop
        reconcile('cart-update');
      });
    }
    reconcile('init'); // catch carts that already have a mattress on page load
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
